import { jwtDecode } from '@/helpers/jwt'
import store from '@/store'

let initialState = {
  locale: 'de'
}

export default {
  state: () => initialState,
  mutations: {
    SET_LOCALE(state, locale) {
      state.locale = locale
    },
    RESET_ACCOUNT(state) {
      const s = initialState
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    }
  },
  actions: {
    setLocale({ commit }, locale) {
      commit('SET_LOCALE', locale)
    },
    resetAccount({ commit }) {
      commit('RESET_ACCOUNT')
    }
  },
  getters: {
    locale: state => {
      return state.locale
    },
    userId: () => {
      let tokenDecoded = jwtDecode(store.getters.jwt)
      return tokenDecoded.sub !== '' ? tokenDecoded.sub : ''
    }
  }
}
